import { render, staticRenderFns } from "./contractualProduct.vue?vue&type=template&id=ec6d6c6e"
import script from "./contractualProduct.vue?vue&type=script&lang=js"
export * from "./contractualProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports